import React from 'react';

import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import AddIcon from '@atlaskit/icon/core/add';

import { Button } from './themed/migration';

type CreateButtonProps = {
	children: React.ReactNode;
	onClick?: (e: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
	testId?: string;
	/**
	 * An optional name used to identify events for [React UFO (Unified Frontend Observability) press interactions](https://developer.atlassian.com/platform/ufo/react-ufo/react-ufo/getting-started/#quick-start--press-interactions). For more information, see [React UFO integration into Design System components](https://go.atlassian.com/react-ufo-dst-integration).
	 */
	interactionName?: string;
};

/**
 * __Create button__
 *
 * The create button for the top navigation.
 */
export const CreateButton = ({ children, onClick, testId, interactionName }: CreateButtonProps) => (
	<Button
		appearance="primary"
		iconBefore={AddIcon}
		onClick={onClick}
		testId={testId}
		interactionName={interactionName}
	>
		{children}
	</Button>
);
